import React from "react";
import logo from "./logo.svg";
import "./App.css";
import Routing from "../src/Routing/Routing";

function App() {
  return (
    <div className="App">
      <div>
        <Routing />
      </div>
    </div>
  );
}

export default App;
